import { useEffect, useRef, useState } from 'react'
import { ConvertPriceToString } from '../../Helpers/CustomConverter'
import ProductInOrderSummary from '../../Pages/Shop/Components/ProductComponents/ProductInOrderSummary'
import { useNavigate } from 'react-router-dom'
import { useWarehouse } from '../../Providers/WarehouseProvider'
import { useCompanyInfo } from '../../Providers/CompanyInfoProvider'
import { LuCopy } from "react-icons/lu";
import { toast } from 'react-toastify'
import useGetBankTransferData from './Hooks/useGetBankTransferData'
import { useOrder } from '../../Providers/OrderProvider'
import { SendOrderFiles } from '../../Services/FileService'
import { useConfig } from '../../Providers/ConfigProvider'
import { useCustomer } from '../../Providers/CustomerProvider'
import { useParams } from '../../Providers/ParamsProvider'
import useCommonFunctions from '../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions'
import { useCart } from '../../Providers/CartProvider'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'
import ScrollUpArrow from '../Components/ScrollUpArrow'
import { useOffers } from '../../Providers/OffersProvider'
import { useDiscount } from '../../Providers/DiscountProvider'

const OrderCompleted = ({ order, basket, isBankTransfer }) => {
    const didSendRef = useRef(false)
    const { warehouses } = useWarehouse()
    let selectedWarehouse = warehouses.find(w => w.id === order.whID)
    const { companyInfoData } = useCompanyInfo()
    const navigate = useNavigate()
    const { bankTransferData } = useGetBankTransferData(order.siteID)
    const { orderInfo, setOrderInfo, clearOrderInfo } = useOrder()
    const { api } = useConfig()
    const { handleGetCreditInfo, clearTemporaryAddressAndAuthorizedPerson } = useCustomer()
    const { isMobile } = useParams()
    const { handleCopyToClipboard } = useCommonFunctions()
    const { getBasketTotalValue, handleClearCartItems } = useCart()
    const totalBasketAmount = getBasketTotalValue(basket.basketItems)
    const { orderItemsFromOffer } = useOffers()
    // const { paymentCreate } = usePayment()
    // const [paymentUrl, setPaymentUrl] = useState(null)
    const totalBasketAmountOffer = getBasketTotalValue(orderItemsFromOffer)
    const { handleClearVoucher } = useDiscount()

    useEffect(() => { //Czyszczenie danych zamówienia po wyjści z okna podsumowania
        return () => {
            clearOrderInfo()
            handleClearCartItems()
            clearTemporaryAddressAndAuthorizedPerson()
            handleClearVoucher()
        }
    }, [])

    useEffect(() => {
        handleGetCreditInfo()
        if (order && orderInfo.attachments.length > 0) { //Wysłanie załączników po złożeniu zamówienia
            handleSendAttachments()
        }

        if (order && order.payments[0].formId == "O") {
            // handleCreatePayment()
        }

    }, [order])

    // const handleCreatePayment = async () => {
    //     const res = await paymentCreate({ orderId: `${order.supplierOrderID}-${order.siteID}`, amount: totalCostGross.toString(), customerEmail: order.orderingPerson.email, paymentTitle: `Zamówienie e-Handel nr ${order.supplierOrderID}${order.siteID}`, card: "", paymentExpDate: "20251009111111" })
    //     setPaymentUrl(res);
    // }

    // useEffect(() => {
    //     if (paymentUrl) {
    //         if (paymentUrl.length > 0) {
    //             window.location.href = paymentUrl; //DK NIE MOŻEMY TAK UŻYWAĆ NAWIGACJI BO TKENY SIE POPSUJA!!!!!!!
    //         }
    //     }
    // }, [paymentUrl])

    // const handlePaymentButtonClick = () => {
    //     if (paymentUrl.length > 0) {
    //         window.location.href = paymentUrl; //DK NIE MOŻEMY TAK UŻYWAĆ NAWIGACJI BO TKENY SIE POPSUJA!!!!!!!
    //     } else {
    //         // handleCreatePayment()
    //     }
    // }

    const handleSendAttachments = async () => {
        if (didSendRef.current) {
            return
        }
        didSendRef.current = true
        const promise = SendOrderFiles(api, orderInfo.attachments, order.supplierOrderID, order.siteID)
        toast.promise(
            promise,
            {
                pending: 'Wysyłanie załączników...',
                success: {
                    render({ data }) {
                        setOrderInfo(prev => ({
                            ...prev,
                            attachments: []
                        }))
                        return `Poprawnie dodano załącznik do zamówienia`
                    }
                },
                error: {
                    render({ data }) {
                        setOrderInfo(prev => ({
                            ...prev,
                            attachments: []
                        }))
                        return `Błąd w trakcie dodawania załącznika do zamówienia`
                    }
                }
            }
        )
    }

    const mergeOrderBasket = (orderItems, basketItems) => {
        if (orderItems.length === 0 || basketItems.length === 0) {
            return []
        }
        return orderItems.map(item => {
            const basketItem = basketItems.find(b => b.product.index === item.supplierArtCode) || {}
            return {
                index: item.supplierArtCode,
                title: basketItem.product.title,
                label: basketItem.product.label,
                baseUnit: item.orderUnit,
                qty: item.orderedQty,
                priceNet: item.netPrice,
                currency: basketItem.product.currency || '',
                priceGross: item.grossPrice,
                taxRate: basketItem.product.taxRate,
                photoFileNames: basketItem.product.photoFileNames || null
            }
        })
    }

    const email = selectedWarehouse ? (selectedWarehouse.email ? selectedWarehouse.email : companyInfoData.email) : companyInfoData.email
    const phone = selectedWarehouse ? (selectedWarehouse.phone ? selectedWarehouse.phone : companyInfoData.phone) : companyInfoData.phone
    const items = orderItemsFromOffer.length > 0 ? orderItemsFromOffer : basket.basketItems
    const mergedList = mergeOrderBasket(order.items, items)
    const summaryAlign = isMobile ? 'justify-content-start' : 'justify-content-end'
    return (
        <ErrorBoundary>
            <ScrollUpArrow />
            <div className='container-fluid container-fluid-with-paddings'>
                <div className="row">
                    <div className="col-12 col-xl-6 mt-5">
                        <div className='order-completed'>
                            <div className='row justify-content-center align-items-center'>
                                <b style={{ fontWeight: '50px' }}>Dziękujemy za zakupy w TG Instalacje</b>
                                <span className='mt-3'>{`Numer zamówienia: ${order.supplierOrderID}/${order.siteID}`}</span>
                                <span> Twoje zamówienie zostało poprawnie złożone i trafiło do realizacji.</span>
                                <span>O jego postępach zostaniesz poinformowany mailowo.</span>
                                <div className='row justify-content-center mt-3'>
                                    <b>Jeśli masz pytania napisz na adres:</b>
                                    <span>{`${email} lub telefoniczne ${phone}`}</span>
                                </div>
                                <div className="d-flex flex-column justify-content-center mt-5">
                                    <b>Do zapłaty: {ConvertPriceToString(orderItemsFromOffer.length > 0 ? totalBasketAmountOffer.totalGross : totalBasketAmount.totalGross)}</b>
                                    {/* {order.payments[0].formId == "O" && <div>{paymentUrl != null ? <button className='btn-app-secondary ms-5 me-5' onClick={() => handlePaymentButtonClick()}>Zapłać</button> : <LoadingSpinner />}</div>} */}
                                    <button className='btn-app-secondary mt-4 ms-5 me-5' onClick={() => navigate('/')}>Przejdź na stronę główną</button>
                                </div>
                            </div>
                        </div>
                        {isBankTransfer && bankTransferData && <div className="main-container-holder row d-flex flex-column text-center mt-4 ms-5 me-5" style={{ border: 0 }}>
                            <span>Wykonaj przelew na dane:</span>
                            {/* <b>{companyInfoData.name}</b> */}
                            <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(bankTransferData.companyName)}>
                                <b>{bankTransferData.companyName}</b>
                                <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                            </div>
                            {/* <b>{selectedWarehouse.street}</b> */}
                            {/* <b>{`${selectedWarehouse.zipCode} ${selectedWarehouse.city}`}</b> */}
                            <span className='mt-3'>{bankTransferData.bankName}</span>
                            <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(bankTransferData.accountNo)}>
                                <b>{bankTransferData.accountNo}</b>
                                <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                            </div>
                            <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(orderItemsFromOffer.length > 0 ? totalBasketAmountOffer.totalGross : totalBasketAmount.totalGross)}>
                                <span>Kwota do zapłaty: <b>{ConvertPriceToString(orderItemsFromOffer.length > 0 ? totalBasketAmountOffer.totalGross : totalBasketAmount.totalGross)}</b></span>
                                <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                            </div>
                            <div className='d-flex justify-content-center align-items-center' onClick={() => handleCopyToClipboard(`${order.supplierOrderID}/${order.siteID}`)}>
                                <span>Tytułem <b>{`${order.supplierOrderID}/${order.siteID}`}</b></span>
                                <LuCopy className='ms-3 primary-accent-color-text element-pointer' />
                            </div>
                        </div>}
                    </div>
                    <div className="col-12 col-xl-6 mt-3 product-in-order-summary">
                        <div className="d-flex justify-content-between mt-4 mb-4">
                            <b className='ms-3'>Produkty na zamówieniu</b>
                            {!isMobile && <div className="d-flex flex-column me-5">
                                <b>Wartość netto</b>
                                <span>Wartość brutto</span>
                            </div>}
                        </div>
                        {mergedList.length > 0 && mergedList.map((item, key) =>
                            <ProductInOrderSummary
                                key={key}
                                photoFileName={item.photoFileNames ? item.photoFileNames[0] : null}
                                title={item.title}
                                label={item.label}
                                baseUnit={item.baseUnit}
                                qty={item.qty}
                                priceNet={item.priceNet}
                                currency={item.currency}
                                priceGross={item.priceGross}
                                taxRate={item.taxRate}
                            />
                        )}
                        <div className="row mt-4">
                            <div className={`col-11 d-flex ${summaryAlign}`}>
                                <span className='me-2'>Koszt wysyłki</span>
                                <span>{ConvertPriceToString(order.deliveryCost)}</span>
                            </div>
                        </div>
                        <div className="row mt-2 mb-5">
                            <div className={`col-11 d-flex ${summaryAlign}`}>
                                <b className='me-2'>Suma brutto</b>
                                <b>{ConvertPriceToString(orderItemsFromOffer.length > 0 ? totalBasketAmountOffer.totalGross : totalBasketAmount.totalGross)}</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    )
}

export default OrderCompleted